module.exports = __webpack_public_path__ + "static/img/mobile_title.f0cd1c3c.png";